"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useContext, useState } from "react";
import { v4 as uuid } from "uuid";
import NotificationContainer from "./notification-container.js";
const NotificationContext = React.createContext(undefined);
function flattenNotifications(stacks) {
    return Object.values(stacks).flatMap(stack => stack.notifications);
}
export const NotificationProvider = (_a) => {
    var { children, stacked: defaultStacked } = _a, props = __rest(_a, ["children", "stacked"]);
    const [stacks, setStacks] = useState({});
    const removeNotification = useCallback((id) => setStacks(prevStacks => {
        var _a;
        const notification = flattenNotifications(prevStacks).find(item => item.id === id);
        let key;
        if (!(notification === null || notification === void 0 ? void 0 : notification.closable)) {
            key = "stuck";
        }
        else if (notification === null || notification === void 0 ? void 0 : notification.stacked) {
            key = (notification === null || notification === void 0 ? void 0 : notification.color) || "primary";
        }
        else {
            key = "unstacked";
        }
        if (id === (notification === null || notification === void 0 ? void 0 : notification.id)) {
            (_a = notification.onClose) === null || _a === void 0 ? void 0 : _a.call(notification);
            return Object.assign(Object.assign({}, prevStacks), { [key]: {
                    notifications: prevStacks[key].notifications.filter(n => n.id !== id),
                    lastUpdated: prevStacks[key].lastUpdated,
                } });
        }
        return prevStacks;
    }), []);
    const removeAllNotifications = useCallback(() => {
        setStacks(prevStacks => {
            var _a;
            for (const n of flattenNotifications(prevStacks)) {
                (_a = n.onClose) === null || _a === void 0 ? void 0 : _a.call(n);
            }
            return {};
        });
    }, []);
    const addNotification = useCallback(function (title, content, _a = {}) {
        var { closable = true, color = "primary", stacked = defaultStacked } = _a, rest = __rest(_a, ["closable", "color", "stacked"]);
        const id = uuid();
        let key;
        if (!closable) {
            key = "stuck";
        }
        else if (stacked) {
            key = color;
        }
        else {
            key = "unstacked";
        }
        const notification = Object.assign({ id, title, children: content, closable, color, stacked }, rest);
        setStacks(prevStacks => {
            var _a;
            return (Object.assign(Object.assign({}, prevStacks), { [key]: {
                    notifications: [notification, ...(((_a = prevStacks[key]) === null || _a === void 0 ? void 0 : _a.notifications) || [])],
                    lastUpdated: Date.now(),
                } }));
        });
        return id;
    }, [defaultStacked]);
    return (_jsxs(NotificationContext.Provider, { value: { addNotification, removeNotification, removeAllNotifications }, children: [_jsx(NotificationContainer, Object.assign({ stacks: stacks }, props)), children] }));
};
export function useNotification() {
    const ctx = useContext(NotificationContext);
    if (!ctx) {
        throw new Error("Cannot use without Notification Provider");
    }
    return ctx;
}
export default NotificationProvider;
//# sourceMappingURL=notification-provider.js.map